module.exports = __webpack_public_path__ + "static/south-america-map-919e39527ebcc65877397c7fa218f714.svg";